export default class NewsTag {
    public id: string = null;
    public category: string = null;
    public title: string = null;

    constructor() { }

}